<template>
  <div id="kontaktformular" class="px-content pb-12">
    <div class="flex justify-center">
      <h2 class="headline">Kontakt</h2>
    </div>

    <p>Haben wir Ihr Interesse geweckt? Dann schreiben sie uns ganz unkompliziert. Wir melden uns bei Ihnen.</p>

    <div v-if="!form_sent">
      <Textfield
        title="Name"
        placeholder="Ihr Name"
        v-model="form.name"
        :errorMsg="errors.name"
        class="mb-4"
      />

      <Textfield
        title="E-Mail"
        placeholder="Ihre E-Mail-Adresse"
        v-model="form.email"
        :errorMsg="errors.email"
        class="mb-4"
      />

      <Textfield
        title="Ort (optional)"
        placeholder="Ihr Ort"
        v-model="form.ort"
        class="mb-4"
      />

      <div class="mb-4">
        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
          Nachricht
        </label>
        <textarea
          v-bind:class="{ formElementError: errors.message }"
          class="inputField focus:outline-none focus:bg-white focus:border-gray-500"
          placeholder="Ihre Nachricht"
          rows="5"
          v-model="form.message"
        ></textarea>
        <p v-if="errors.message" class="text-red-500 text-xs italic">{{ errors.message }}</p>
      </div>

      <button
        class="block w-full shadow bg-brand-yellow border-brand-yellow hover:border-brand-blue border-2 focus:shadow-outline focus:outline-none text-brand-blue font-bold py-2 px-4 rounded"
        type="button"
        v-on:click="checkForm()"
      >
        Anfrage senden
      </button>
    </div>

    <div v-if="form_sent && !form_sent_error" class="mt-4 text-gray-800">
      <p class="font-semibold">Vielen Dank für Ihre Anfrage!</p>
      <p class="mt-2">Wir melden uns in Kürze bei Ihnen.</p>
    </div>

    <div v-if="form_sent && form_sent_error" class="mt-4 text-gray-800">
      <p class="font-semibold">Sorry, da ist etwas schiefgelaufen.</p>
      <p class="mt-2">
        Bitte kontaktieren Sie uns direkt unter
        <a class="link" href="mailto:info@schlosserei-raichle.de">info@schlosserei-raichle.de</a>.
      </p>
    </div>
  </div>
</template>

<script>
import Textfield from "./form/Textfield.vue";

export default {
  name: "ProduktKontaktformular",
  components: { Textfield },
  props: {
    product: {
      type: String,
      required: true,
    },
    pixelEvent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        ort: "",
        message: "",
      },
      errors: {
        name: "",
        email: "",
        message: "",
      },
      form_sent: false,
      form_sent_error: false,
    };
  },
  methods: {
    checkForm() {
      this.errors = { name: "", email: "", message: "" };
      let hasErrors = false;

      if (!this.form.name) {
        this.errors.name = "Bitte gib Deinen Namen an.";
        hasErrors = true;
      }
      if (!this.form.email) {
        this.errors.email = "Bitte gib Deine E-Mail-Adresse an.";
        hasErrors = true;
      }
      if (!this.form.message) {
        this.errors.message = "Bitte gib eine Nachricht ein.";
        hasErrors = true;
      }
      if (hasErrors) return;

      fetch("/send_produkt_form.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...this.form, product: this.product }),
      })
        .then((response) => {
          if (!response.ok) throw "Error " + response.status;
          return response.json();
        })
        .then(() => {
          this.form_sent_error = false;
          this.form_sent = true;
          this.$metaPixel.trackCustom(this.pixelEvent);
        })
        .catch(() => {
          this.form_sent_error = true;
          this.form_sent = true;
        });
    },
  },
};
</script>
